export const PLACE_DETAIL_ISR_REVALIDATE_SECONDS = 21600 // 6h (60 * 60 * 6)

export const PLACE_DETAIL_CANONICAL_BASE =
  'https://service.mycle.co.kr/v2/place'
